import React from 'react';
import PropTypes from 'prop-types';

import SubscriptionsTrolleyInfoBoxContainer from '../../subscriptions/containers/SubscriptionsTrolleyInfoBoxContainer';

const TrolleyMenuItemsDecorator = ({ section }) => {
  const sectionKey = section.toUpperCase();
  switch (sectionKey) {
    case 'SUBSCRIPTIONS': {
      return <SubscriptionsTrolleyInfoBoxContainer />;
    }
    default:
      return null;
  }
};

TrolleyMenuItemsDecorator.propTypes = {
  section: PropTypes.string,
};

TrolleyMenuItemsDecorator.defaultProps = {
  section: '',
};

export default TrolleyMenuItemsDecorator;
